<template>
  <!-- modal Pasien Create-->
  <b-modal
    :id="modalId"
    ref="modalPasienCreate"
    :static="true"
    modal-class="modal-fullscreen"
    scrollable
    no-close-on-backdrop
    @shown="isModalOpen = true"
    @hidden="isModalOpen = false"
    @close="closeModal"
  >
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <div class="d-flex align-items-center">
          <div class="mr-2" style="min-width: 180px;">
            <b-form-select
              v-model="form['status_pasien']"
              size="sm"
            >
              <b-form-select-option
                v-for="option in (references['Status Pasien'] || [])"
                :key="option.value"
                :value="option.value"
              >
                {{ option.title }}
              </b-form-select-option>
            </b-form-select>
          </div>
          <b-form-checkbox
            v-model="pasienTakDikenal"
            switch
            class="mr-3"
          >
            Pasien Tak Dikenal
          </b-form-checkbox>
          <b-button variant="outline-secondary" size="sm" @click="close()">
            <feather-icon icon="XIcon" />
          </b-button>
        </div>
      </div>
    </template>

    <!-- Custom Footer -->
    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <b-button variant="outline-secondary" @click="closeModal">
          <feather-icon icon="XIcon" class="mr-1" />
          Tutup
        </b-button>
        <div class="d-flex align-items-center">
          <b-button
            v-if="type === 'create'"
            variant="warning"
            class="mr-2"
            @click="confirmReset"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-1" />
            Reset
          </b-button>
          <b-button variant="primary" @click="handleOk" :disabled="isLoading">
            <feather-icon v-if="!isLoading" icon="SaveIcon" class="mr-1" />
            <b-spinner v-if="isLoading" small class="mr-1" />
            {{ isLoading ? 'Menyimpan...' : 'Simpan' }}
          </b-button>
        </div>
      </div>
    </template>

    <!-- <b-card > -->
    <b-overlay :show="isLoading" rounded="sm" opacity="0.6">
      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..." />
          <p class="mt-2">{{ type === 'create' ? 'Menyimpan pasien baru...' : 'Mengubah data pasien...' }}</p>
        </div>
      </template>
      <validation-observer ref="addPasien" @invalid="onValidationFailed">
        <b-form @submit.prevent="formSubmitted">
          <b-row class="px-1">
          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Data Identitas
              </div>
            </div>
          </b-col>
          <b-col md="2" v-if="editableNorm && this.type === 'create'">
            <ValidationProvider
              v-slot="validationContext"
              name="NORM"
              rules="required|numeric|min:1"
            >
              <b-form-group>
                <div class="form-label-group">
                  <b-input-group>
                    <b-form-input
                      id="gelar-depan"
                      v-model="form['norm']"
                      size="sm"
                      placeholder="NORM"
                      :state="getValidationState(validationContext)"
                    />
                    <b-input-group-append>
                      <b-button size="sm" @click="getLatestNorm">
                        <icon icon="material-symbols:download" />
                      </b-button>
                      <b-button size="sm" @click="checkNorm">
                        <icon icon="material-symbols:search" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <label>NORM</label>
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col md="2" v-if="editableNormManual">
            <ValidationProvider
              v-slot="validationContext"
              name="NORM Manual"
              rules="max:50"
            >
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="norm-manual"
                    v-model="form['norm_manual']"
                    size="sm"
                    placeholder="NORM Manual"
                    :state="getValidationState(validationContext)"
                  />
                  <label>NORM Manual</label>
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col md="3">
            <ValidationProvider
              v-slot="validationContext"
              name="NIK"
              :rules="pasienTakDikenal ? '' : 'required|max:16|min:16|numeric'"
            >
              <b-form-group>
                <div class="form-label-group">
                  <b-input-group>
                    <b-form-input
                      id="nik-input"
                      v-model="form.nik"
                      size="sm"
                      placeholder="NIK"
                      maxlength="16"
                      type="tel"
                      :state="getValidationState(validationContext)"
                      @input="
                        (no) =>
                          nikHandler(
                            no,
                            'tanggal_lahir_formatted',
                            'jenis_kelamin'
                          )
                      "
                    />
                    <b-input-group-append>
                      <b-button size="sm" @click="autofillBy('nik', form.nik)">
                        <icon icon="material-symbols:search" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <label>NIK</label>
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col md="3">
            <ValidationProvider
              v-slot="validationContext"
              name="No. BPJS"
              :rules="pasienTakDikenal ? '' : 'max:13|min:13|numeric'"
            >
              <b-form-group>
                <div class="form-label-group">
                  <b-input-group>
                    <b-form-input
                      id="no-bpjs-input"
                      v-model="form.no_bpjs"
                      size="sm"
                      placeholder="No. BPJS"
                      maxlength="13"
                      type="tel"
                      :state="getValidationState(validationContext)"
                    />
                    <b-input-group-append>
                      <b-button size="sm" @click="autofillBy('noka', form.no_bpjs)">
                        <icon icon="material-symbols:search" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <label>No. BPJS</label>
                  <small class="text-danger">{{ validationContext.errors[0] }}</small>
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Data Pribadi
              </div>
            </div>
          </b-col>
          <!-- data pribadi tab -->
          <b-row class="px-1">
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="gelar-depan"
                    v-model="form['gelar_depan']"
                    size="sm"
                    placeholder="Gelar Depan eg: dr/Ny/Hj/Tn"
                  />
                  <label>Gelar Depan</label>
                </div>
              </b-form-group>
            </b-col>
            <!-- Group 1 -->
            <b-col md="6">
              <ValidationProvider
                v-slot="validationContext"
                name="Nama"
                rules="required"
              >
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="nama-lengkap"
                      v-model="form['nama']"
                      size="sm"
                      :state="getValidationState(validationContext)"
                      placeholder="[ Nama Lengkap Tanpa Gelar ]"
                    />
                    <label>Nama Lengkap Tanpa Gelar</label>
                    <small class="text-danger">{{ validationContext.errors[0] }}</small>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="nama-panggilan"
                    v-model="form['panggilan']"
                    size="sm"
                    placeholder="[ Nama Panggilan ]"
                  />
                  <label>Nama Panggilan</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="gelar-belakang"
                    v-model="form['gelar_belakang']"
                    size="sm"
                    placeholder="[ Gelar Belakang ]"
                  />
                  <label>Gelar Belakang</label>
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 1 -->
            <!-- Start Group 2 -->
            <b-col md="2">
              <ValidationProvider
                v-slot="validationContext"
                name="Tempat Lahir"
                :rules="pasienTakDikenal ? '' : 'required|alpha'"
              >
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="tempat-lahir"
                      v-model="form['tempat_lahir']"
                      size="sm"
                      :state="getValidationState(validationContext)"
                      placeholder="[ Tempat Lahir ]"
                    />
                    <label>Tempat Lahir</label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <ValidationProvider
                v-slot="validationContext"
                name="Tanggal Lahir"
                :rules="pasienTakDikenal ? '' : 'required'"
              >
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="tanggal-lahir"
                      v-model="form['tanggal_lahir_formatted']"
                      v-mask="'##/##/####'"
                      size="sm"
                      :max="nowDate"
                      locale="id"
                      type="tel"
                      placeholder="[ Tgl. Lahir (DD/MMM/YYYY) ]"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form.jenis_kelamin"
                    class="select-size-sm"
                    :options="references['Jenis Kelamin'] || []"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Jenis Kelamin ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 2 -->
            <!-- Start Group 3 -->
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form.agama"
                    class="select-size-sm"
                    :options="references['Agama'] || []"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Agama ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['status_perkawinan']"
                    class="select-size-sm"
                    :options="references['Status Perkawinan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Status Perkawinan ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['pendidikan']"
                    class="select-size-sm"
                    :options="references['Pendidikan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Pendidikan ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['pekerjaan']"
                    class="select-size-sm"
                    :options="references['Pekerjaan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Pekerjaan ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['suku']"
                    class="select-size-sm"
                    :options="references['Daftar Suku']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Suku ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['golongan_darah']"
                    class="select-size-sm"
                    :options="references['Golongan Darah']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Golongan Darah ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 3 -->
            <!-- Start Group 4 -->
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['kewarganegaraan']"
                    class="select-size-sm"
                    :options="references['kewarganegaraan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Kewarganegaraan ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3"></b-col>
            <b-col md="3">
              <ValidationProvider
                v-slot="validationContext"
                name="No. Handphone"
                :rules="pasienTakDikenal ? '' : 'required'"
              >
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="no-telepon"
                      v-model="form['nomor_kontak_telp']"
                      size="sm"
                      :state="getValidationState(validationContext)"
                      type="number"
                      placeholder="[ No. Handphone ]"
                      @input="syncPhone"
                    />
                    <label>No. Handphone</label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                v-slot="validationContext"
                name="No. WhatsApp"
                :rules="pasienTakDikenal ? '' : 'required'"
              >
                <b-form-checkbox
                  v-model="sameAsPhone"
                  :value="true"
                  class="float-right ml-1"
                >
                  <small>Sama dgn No. Telepon</small>
                </b-form-checkbox>
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="no-whatsapp"
                      v-model="form['nomor_kontak_wa']"
                      size="sm"
                      :state="getValidationState(validationContext)"
                      type="number"
                      placeholder="[ No. Whatsapp ]"
                    />
                    <label>No. Whatsapp</label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                v-slot="validationContext"
                name="Email"
                rules="email"
              >
                <b-form-group>
                  <div class="form-label-group">
                    <b-form-input
                      id="mc-email"
                      v-model="form['email']"
                      size="sm"
                      :state="getValidationState(validationContext)"
                      name="email"
                      type="email"
                      placeholder="[ Email ]"
                    />
                    <label>Email</label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <!-- End Group 4 -->
          </b-row>
          <!-- perusahaaan -->
          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Perusahaan
              </div>
            </div>
          </b-col>

          <b-row class="px-1">
            <b-col md="4">
              <b-form-group label="Perusahaan" label-for="perusahaan">
                <b-form-input v-model="form['perusahaan']" list="perusahaan" placeholder="[ Perusahaan ]" size="sm" />
                <datalist id="perusahaan" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Bagian" label-for="bagian">
                <b-form-input v-model="form['bagian']" list="bagian" placeholder="[ Bagian ]" size="sm" />
                <datalist id="bagian" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Nomor Induk Pegawai" label-for="nomor_induk_pegawai">
                <b-form-input v-model="form['nomor_induk_pegawai']" placeholder="[ NIP ]" size="sm" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Alamat Lengkap
              </div>
            </div>
          </b-col>
          <!-- alamat lengkap tab -->
          <b-row class="px-1">
            <b-col md="6">
              <!-- Start Group 1 -->
              <b-row class="mt-3">
                <b-col md="12">
                  <b-form-group>
                    <div class="form-label-group">
                      <b-form-input
                        id="alamat"
                        v-model="form['alamat_identitas']"
                        placeholder="[ Alamat Sesuai KTP ]"
                        size="sm"
                        @input="syncAlamat"
                      />
                      <label for="">Alamat Sesuai KTP</label>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- End Group 1 -->
              <!-- Start Group 2 -->
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['provinsi_identitas']"
                        class="select-size-sm"
                        :options="provinsi_identitas"
                        label="title"
                        placeholder="[ Provinsi ]"
                        @change="syncAlamat"
                        @input="
                          $store.dispatch('wilayahIdentitas/getWilayah')
                          syncAlamat()
                        "
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['wilayah_identitas']"
                        class="select-size-sm"
                        :options="wilayah_identitas"
                        label="title"
                        placeholder="[ Kabupaten/Kota ]"
                        @change="syncAlamat"
                        @input="
                          $store.dispatch('wilayahIdentitas/getKecamatan')
                          syncAlamat()
                        "
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['kecamatan_identitas']"
                        class="select-size-sm"
                        :options="kecamatan_identitas"
                        label="title"
                        placeholder="[ Kecamatan ]"
                        @input="
                          $store.dispatch('wilayahIdentitas/getKelurahan')
                          syncAlamat()
                        "
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['kelurahan_identitas']"
                        class="select-size-sm"
                        :options="kelurahan_identitas"
                        label="title"
                        placeholder="[ Kelurahan ]"
                        @input="syncAlamat"
                      />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- End Group 2 -->
              <!-- Start Group 3 -->
              <b-row>
                <b-col md="3">
                  <ValidationProvider
                    v-slot="validationContext"
                    name="RT"
                    rules="numeric"
                  >
                    <b-form-group>
                      <b-input-group size="sm" prepend="RT">
                        <b-form-input
                          id="rt"
                          v-model="form['rt_identitas']"
                          size="sm"
                          :state="getValidationState(validationContext)"
                          @input="syncAlamat"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="3">
                  <ValidationProvider
                    v-slot="validationContext"
                    name="RW"
                    rules="numeric"
                  >
                    <b-form-group>
                      <b-input-group size="sm" prepend="RW">
                        <b-form-input
                          id="rw"
                          v-model="form['rw_identitas']"
                          size="sm"
                          :state="getValidationState(validationContext)"
                          @input="syncAlamat"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="6">
                  <ValidationProvider
                    v-slot="validationContext"
                    name="Kode Pos"
                    rules="numeric"
                  >
                    <b-form-group>
                      <b-input-group size="sm" prepend="Kodepos">
                        <b-form-input
                          id="kodepos"
                          v-model="form['kodepos_identitas']"
                          size="sm"
                          :state="getValidationState(validationContext)"
                          @input="syncAlamat"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <!-- End Group 3 -->
            </b-col>
            <b-col md="6">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-checkbox
                    v-model="sameAsIdentitas"
                  >
                    Alamat Domisili Sama Dengan Alamat KTP
                  </b-form-checkbox>
                </div>
              </b-form-group>
              <!-- Start Group 1 -->
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <div class="form-label-group">
                      <b-form-input
                        id="alamat"
                        v-model="form['alamat']"
                        size="sm"
                        :disabled="sameAsIdentitas"
                        placeholder="[ Alamat Domisili ]"
                      />
                      <label>Alamat Domisili</label>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- End Group 1 -->
              <!-- Start Group 2 -->
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['provinsi']"
                        class="select-size-sm"
                        :disabled="sameAsIdentitas"
                        :options="provinsi"
                        label="title"
                        placeholder="[ Provinsi ]"
                        @input="$store.dispatch('wilayah/getWilayah')"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['wilayah']"
                        class="select-size-sm"
                        :disabled="sameAsIdentitas"
                        :options="wilayah"
                        placeholder="[ Kabupaten/Kota ]"
                        label="title"
                        @input="$store.dispatch('wilayah/getKecamatan')"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['kecamatan']"
                        class="select-size-sm"
                        :disabled="sameAsIdentitas"
                        :options="kecamatan"
                        placeholder="[ Kecamatan ]"
                        label="title"
                        @input="$store.dispatch('wilayah/getKelurahan')"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <v-select
                        v-model="form['kelurahan']"
                        class="select-size-sm"
                        :disabled="sameAsIdentitas"
                        :options="kelurahan"
                        placeholder="[ Kelurahan ]"
                        label="title"
                      />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- End Group 2 -->
              <!-- Start Group 3 -->
              <b-row>
                <b-col md="3">
                  <b-form-group>
                    <div class="form-label-group">
                      <b-input-group size="sm" prepend="RT">
                        <b-form-input
                          id="rt"
                          v-model="form['rt']"
                          size="sm"
                          :disabled="sameAsIdentitas"
                        />
                      </b-input-group>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                    <div class="form-label-group">
                      <b-input-group size="sm" prepend="RW">
                        <b-form-input
                          id="rw"
                          v-model="form['rw']"
                          size="sm"
                          :disabled="sameAsIdentitas"
                        />
                      </b-input-group>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <div class="form-label-group">
                      <b-input-group size="sm" prepend="Kodepos">
                        <b-form-input
                          id="kodepos"
                          v-model="form['kodepos']"
                          size="sm"
                          :disabled="sameAsIdentitas"
                        />
                      </b-input-group>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- End Group 3 -->
            </b-col>
          </b-row>
          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Data Keluarga
              </div>
            </div>
          </b-col>
          <b-row class="px-1 mt-1">
            <b-col md="12">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="mc-nama-ibu"
                    v-model="form['ibu_kandung']"
                    size="sm"
                    placeholder="[ Nama Lengkap Ibu Kandung Tanpa Gelar]"
                  />
                  <label for="">Nama Lengkap Ibu Kandung Tanpa Gelar</label>
                </div>
              </b-form-group>
              <h5 class="my-1">
                KELUARGA DEKAT LAINNYA:
              </h5>
            </b-col>
            <!-- Start Group 1 -->
            <b-col md="3">
              <b-form-group>
                <v-select
                  v-model="form['shdk_keluarga']"
                  class="select-size-sm"
                  :options="references['Status Hubungan Dalam Keluarga']"
                  :reduce="(option) => option.value"
                  label="title"
                  placeholder="[ Hubungan Keluarga ]"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="mc-nama-keluarga"
                    v-model="form['nama_keluarga']"
                    size="sm"
                    placeholder="[ Nama Anggota Keluarga ]"
                  />
                  <label>Nama Anggota Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <v-select
                  v-model="form['jenis_kelamin_keluarga']"
                  class="select-size-sm"
                  :options="references['Jenis Kelamin']"
                  :reduce="(option) => option.value"
                  label="title"
                  placeholder="[ Jenis Kelamin ]"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="mc-alamat-keluarga"
                    v-model="form['alamat_keluarga']"
                    size="sm"
                    placeholder="[ Alamat Keluarga ]"
                  />
                  <label>Alamat Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 1 -->
            <!-- Start Group 2 -->
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['id_keluarga']"
                    class="select-size-sm"
                    :options="references['Jenis Kartu Identitas']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="Jenis Kartu Identitas Keluarga"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="no-identitas"
                    size="sm"
                    placeholder="[ No. Identitas Keluarga ]"
                    @input="
                      (no) =>
                        nikHandler(
                          no,
                          'tanggal_lahir_keluarga_formatted',
                          'jenis_kelamin_keluarga'
                        )
                    "
                  />
                  <label>No. Identitas Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="tempat-lahir"
                    v-model="form['tempat_lahir_keluarga']"
                    size="sm"
                    placeholder="[ Tempat Lahir Keluarga ]"
                  />
                  <label>Tempat Lahir Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="tanggal-lahirkeluarga"
                    v-model="form['tanggal_lahir_keluarga_formatted']"
                    v-mask="'##/##/####'"
                    size="sm"
                    locale="id"
                    type="tel"
                    placeholder="Tanggal Lahir Keluarga"
                  />
                  <label>Tgl. Lahir Keluarga (DD/MM/YYYY)</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">

                  <v-select
                    v-model="form['kewarganegaraan_keluarga']"
                    class="select-size-sm"
                    :options="references['kewarganegaraan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Kewarganegaraan ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 2 -->
            <!-- Start Group 3 -->
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">

                  <v-select
                    v-model="form['agama_keluarga']"
                    class="select-size-sm"
                    :options="references['Agama']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Agama Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['status_perkawinan_keluarga']"
                    class="select-size-sm"
                    :options="references['Status Perkawinan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Status Perkawinan Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['pendidikan_keluarga']"
                    class="select-size-sm"
                    :options="references['Pendidikan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Pendidikan Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['pekerjaan_keluarga']"
                    class="select-size-sm"
                    :options="references['Pekerjaan']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Pekerjaan Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    v-model="form['suku_keluarga']"
                    class="select-size-sm"
                    :options="references['Daftar Suku']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Suku Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <div class="form-label-group">
                  <v-select
                    id="GOLONGAN DARAH"
                    v-model="form['golongan_darah_keluarga']"
                    class="select-size-sm"
                    :options="references['Golongan Darah']"
                    :reduce="(option) => option.value"
                    label="title"
                    placeholder="[ Gol. Darah Keluarga ]"
                  />
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 3 -->
            <!-- Start Group 4 -->
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">

                  <b-form-input
                    id="no-telepon"
                    v-model="form['nomor_kontak_keluarga_telp']"
                    size="sm"
                    placeholder="[ No. Telepon Keluarga ]"
                    @input="syncPhoneKeluarga"
                  />
                  <label>No. Telepon Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-checkbox
                v-model="sameAsPhoneKeluarga"
                :value="true"
                class="float-right ml-1"
              >
                <small> Sama dgn No. Telepon</small>
              </b-form-checkbox>
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="no-whatsapp"
                    v-model="form['nomor_kontak_keluarga_wa']"
                    size="sm"
                    placeholder="[ No. Whatsapp Keluarga ]"
                  />
                  <label>No. Whatsapp Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="form-label-group">
                  <b-form-input
                    id="mc-email"
                    v-model="form['email_keluarga']"
                    size="sm"
                    placeholder="[ Email Keluarga ]"
                  />
                  <label>Email Keluarga</label>
                </div>
              </b-form-group>
            </b-col>
            <!-- End Group 4 -->
          </b-row>
          <b-col md="12">
            <div class="divider divider-primary mt-0">
              <div class="divider-text">
                Dokumen Pendukung
              </div>
            </div>
          </b-col>
          <!-- kelengkapan dokumen tab -->
          <b-row class="mt-1 px-1">
            <!-- Start Group 1 -->
            <b-col md="4">
              <b-form-group
                label="KTP"
                label-for="ktp"
              >
                <preview-dokumen :url="form['file_ktp_url']" />
                <b-input-group>
                  <b-form-file
                    v-model="form['file_ktp']"
                    accept="image/*"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                    @input="(file) => previewImage(file, 'file_ktp_url')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="BPJS"
                label-for="bpjs"
              >
                <preview-dokumen :url="form['file_bpjs_url']" />
                <b-input-group>
                  <b-form-file
                    v-model="form['file_bpjs']"
                    accept="image/*"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                    @input="(file) => previewImage(file, 'file_bpjs_url')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="AKTA KELAHIRAN"
                label-for="akta-kelahiran"
              >
                <preview-dokumen :url="form['file_akta_url']" />
                <b-input-group>
                  <b-form-file
                    v-model="form['file_akta']"
                    accept="image/*"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                    @input="(file) => previewImage(file, 'file_akta_url')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="SIM"
                label-for="sim"
              >
                <preview-dokumen :url="form['file_sim_url']" />
                <b-input-group>
                  <b-form-file
                    v-model="form['file_sim']"
                    :value="form['file_sim']"
                    accept="image/*"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                    @input="(file) => previewImage(file, 'file_sim_url')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- End Group 1 -->
            <!-- Start Group 2 -->
            <b-col md="4">
              <b-form-group
                label="NPWP"
                label-for="npwp"
              >
                <preview-dokumen :url="form['file_npwp_url']" />
                <b-input-group>
                  <b-form-file
                    v-model="form['file_npwp']"
                    accept="image/*"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                    @input="(file) => previewImage(file, 'file_npwp_url')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="DOKUMEN PENDUKUNG LAINNYA"
                label-for="LAINNYA"
              >
                <b-input-group>
                  <b-form-file
                    v-model="form['file_lainnya']"
                    drop-placeholder="Drop file here..."
                    placeholder="Choose a file or drop it here..."
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- End Group 2 -->
          </b-row>
        </b-row>
      </b-form>
    </validation-observer>
    </b-overlay>
    <!-- </b-card> -->
  </b-modal>
</template>

<script>
import store from '@/store/index'
import {mapGetters, mapState} from 'vuex'
import {mapFields} from 'vuex-map-fields'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import PreviewDokumen from '@/components/pasien/PreviewDokumen.vue'
import axiosIns from '@/libs/axios'

export default {
  name: 'ModalPasienCreate',
  components: {
    PreviewDokumen,
    ValidationProvider,
    ValidationObserver
  },
  inject: ['settingVal'],
  props: {
    type: {
      type: String,
      default: 'create'
    },
    customId: {
      type: String,
      default: null
    },
    autoNavigate: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalTitle: this.type === 'create'
        ? 'Pendaftaran Pasien Baru'
        : 'Edit Data Pasien',
      modalVisible: this.visible,
      isModalOpen: false,
      email,
      required,
      errors: [],
      tabIndex: 1,
      selected: null,
      sameAsIdentitas: true,
      sameAsPhone: true,
      sameAsPhoneKeluarga: false,
      pasienTakDikenal: false,
      originalStatusPasien: null,
      statusPasienChanged: false,
      isLoading: false,
    }
  },
  computed: {
    editableNorm() {
      return this.settingVal('master:patient:input-norm')
    },
    editableNormManual() {
      return this.settingVal('master:patient:input-norm-manual')
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    nowDate() {
      const data = new Date()
      const year = data.getFullYear()
      const month = this.alterZero((data.getMonth() + 1))
      const day = this.alterZero(data.getDate())
      return `${year}-${month}-${day}`
    },
    ...mapState('wilayah', ['provinsi', 'wilayah', 'kecamatan', 'kelurahan']),
    ...mapState('wilayahIdentitas', {
      provinsi_identitas: 'provinsi',
      wilayah_identitas: 'wilayah',
      kecamatan_identitas: 'kecamatan',
      kelurahan_identitas: 'kelurahan'
    }),
    ...mapGetters('pasien', ['references', 'alamatIdentitas']),
    ...mapFields('pasien', ['form']),
    ...mapState('pasien', ['negara']),
    modalId() {
      return this.customId || `modal-pasien-${this.type}`
    }
  },
  watch: {
    visible(val) {
      this.modalVisible = val
    },
    alamatIdentitas: {
      handler() {
        this.syncAlamat()
      },
      immediate: true,
      deep: true
    },
    sameAsIdentitas: {
      handler() {
        this.syncAlamat()
      },
      immediate: true
    },
    sameAsPhone: {
      handler() {
        this.syncPhone()
      },
      immediate: true
    },
    sameAsPhoneKeluarga: {
      handler() {
        this.syncPhoneKeluarga()
      },
      immediate: true
    },
    'form.status_pasien': {
      handler(newVal, oldVal) {
        // Track if status has been changed
        if (this.type === 'update' && this.originalStatusPasien !== null && oldVal !== undefined) {
          this.statusPasienChanged = (newVal !== this.originalStatusPasien)
        }
      }
    },
    // Watch for reference field changes to ensure proper value handling
    'form.jenis_kelamin': {
      handler(newVal) {
        if (newVal && typeof newVal === 'object' && newVal.value !== undefined) {
          this.form.jenis_kelamin = newVal.value
        }
      }
    },
    'form.agama': {
      handler(newVal) {
        if (newVal && typeof newVal === 'object' && newVal.value !== undefined) {
          this.form.agama = newVal.value
        }
      }
    }
  },
  beforeMount() {
    this.$store.dispatch('wilayah/init')
    this.$store.dispatch('wilayahIdentitas/init')
    this.$store.dispatch('pasien/getReferences')
  },
  mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if (modalId === this.modalId && this.type === 'create') {
        // Clear form first for create mode
        this.$store.commit('pasien/CLEAR_FORM')

        // Set default values after clearing
        this.form.jenis_identitas =
            this.references['Jenis Kartu Identitas'].find((k) => k.value === 1) ||
            null
        this.form.id_keluarga =
            this.references['Jenis Kartu Identitas'].find((k) => k.value === 1) ||
            null
        this.form.kewarganegaraan =
            this.references.kewarganegaraan.find((k) => k.value === 1) ||
            null
        this.form.kewarganegaraan_keluarga =
            this.references.kewarganegaraan.find((k) => k.value === 1) ||
            null
        this.form.status_pasien = 1 // Default to 1 (Hidup / Aktif)

        // Reset local state
        this.sameAsIdentitas = true
        this.sameAsPhone = true
        this.sameAsPhoneKeluarga = false
        this.pasienTakDikenal = false
      }

      // Track original status for edit mode
      if (modalId === this.modalId && this.type === 'update') {
        this.originalStatusPasien = this.form.status_pasien
        this.statusPasienChanged = false
      }
      // if (this.editableNorm && this.type === 'create') this.getLatestNorm()
    })
  },
  methods: {
    closeModal() {
      this.modalVisible = false
      this.$store.dispatch('app/removeOperation', ['createKunjungan'])
      this.$emit('closeModal')
      this.$bvModal.hide(this.modalId)
    },
    async confirmReset() {
      // Check if form has any data
      const hasFormData = this.checkIfFormHasData()

      if (hasFormData) {
        // Show confirmation dialog
        const result = await this.$swal({
          title: 'Konfirmasi Reset',
          text: 'Apakah Anda yakin ingin menghapus seluruh isian pada form ini?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Reset Form',
          cancelButtonText: 'Batal',
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-outline-secondary ml-1'
          },
          buttonsStyling: false
        })

        if (result.isConfirmed) {
          this.resetForm()
        }
      } else {
        // No data in form, reset directly
        this.resetForm()
      }
    },
    checkIfFormHasData() {
      // Check key fields to determine if form has meaningful data
      const form = this.form
      const fieldsToCheck = [
        'norm', 'nik', 'no_bpjs', 'nama', 'gelar_depan', 'panggilan', 'gelar_belakang',
        'tempat_lahir', 'tanggal_lahir_formatted', 'nomor_kontak_telp', 'nomor_kontak_wa',
        'email', 'alamat_identitas', 'alamat', 'perusahaan', 'bagian', 'nomor_induk_pegawai', 'ibu_kandung'
      ]

      return fieldsToCheck.some(field => {
        const value = form[field]
        return value && value !== '' && value !== null && value !== undefined
      })
    },
    resetForm() {
      // Clear form data
      this.$store.commit('pasien/CLEAR_FORM')

      // Set default values
      this.$nextTick(() => {
        this.form.jenis_identitas =
            this.references['Jenis Kartu Identitas'].find((k) => k.value === 1) ||
            null
        this.form.id_keluarga =
            this.references['Jenis Kartu Identitas'].find((k) => k.value === 1) ||
            null
        this.form.kewarganegaraan =
            this.references.kewarganegaraan.find((k) => k.value === 1) ||
            null
        this.form.kewarganegaraan_keluarga =
            this.references.kewarganegaraan.find((k) => k.value === 1) ||
            null
        this.form.status_pasien = 1 // Default to 1 (Hidup / Aktif)

        // Reset local state
        this.sameAsIdentitas = true
        this.sameAsPhone = true
        this.sameAsPhoneKeluarga = false
        this.pasienTakDikenal = false

        // Clear validation errors
        this.$refs.addPasien.reset()

        // Show success message
        this.$dekatoast.success('Form berhasil direset')
      })
    },
    alterZero(val) {
      let setup = ''
      if (val.toString().length === 1) {
        setup = `0${val.toString()}`
      } else {
        setup = val
      }

      return setup
    },
    checkFormValidity() {
      const valid = this.$refs.addPasien.validate()
      this.errors = valid
      return valid
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()

      // Re-entrancy guard. isLoading used to be set inside the async validate()
      // callback below, so every click landing during the ~60-field validation pass
      // queued its own independent submit — :disabled never got a chance to apply.
      if (this.isLoading) return
      this.isLoading = true

      // Skip validation if pasienTakDikenal is checked
      if (this.pasienTakDikenal) {
        // Only validate nama field (required)
        if (!this.form.nama || this.form.nama.trim() === '') {
          this.isLoading = false
          this.$dekatoast.error('Nama pasien harus diisi')
          return
        }
        // Directly submit without full validation
        this.formSubmitted()
        return
      }

      // Always validate NIK field first (critical validation)
      if (!this.form.nik || this.form.nik.trim() === '') {
        this.isLoading = false
        this.$dekatoast.error(
          'NIK Wajib Diisi, nyalakan opsi "Pasien Tak Dikenal" jika tidak memiliki NIK',
          'NIK (Nomor Induk Kependudukan) harus diisi sebelum menyimpan data pasien.',
          'AlertTriangleIcon'
        )
        return
      }

      // Validate NIK format
      if (this.form.nik && this.form.nik.length !== 16) {
        this.isLoading = false
        this.$dekatoast.error(
          'Format NIK Tidak Valid',
          'NIK harus terdiri dari 16 digit angka.',
          'AlertTriangleIcon'
        )
        return
      }

      // Skip validation if in edit mode and only status changed
      if (this.type === 'update' && this.statusPasienChanged && this.originalStatusPasien !== this.form.status_pasien) {
        // Directly submit without validation
        this.formSubmitted()
        return
      }

      // Normal validation flow
      this.checkFormValidity()
      this.$refs.addPasien.validate().then((success,b,c) => {
        if (success) {
          // Trigger submit handler
          // eslint-disable-next-line
          this.formSubmitted()
          requestAnimationFrame(() => {
            this.$refs.addPasien.reset()
          })
        } else {
          // Show validation error toast when submit fails
          this.isLoading = false
          this.onValidationFailed()
        }
      })
    },
    async formSubmitted(extraPayload = {}) {
      try {
        this.isLoading = true
        let success
        let message
        let data

        // Ensure form data integrity
        this.ensureFormDataIntegrity()

        // validation formatted date
        const validate = this.validateDate()
        if (validate === 0) {
          this.$dekatoast.error('Ups, format tanggal salah. Harap periksa kembali isianmu.')
          this.isLoading = false
          return
        }

        let kind
        if (this.type === 'create') {
          const checkNorm = await this.checkNorm()
          if (!checkNorm) {
            this.$dekatoast.error('Ups, NORM tidak valid',
              '👋 Harap periksa kembali NORM yang dimasukkan. 🙅‍♂️🙅', 'AlertTriangleIcon'
            )
            this.isLoading = false
            return;
          }
          [success, message, data, kind] = await this.$store.dispatch('pasien/savePasien', extraPayload)
        } else {
          [success, message, data] = await this.$store.dispatch('pasien/updatePasien')
        }

        // The backend found an existing patient with the same NIK, name and date of
        // birth. Let the operator open that record or deliberately create a second one.
        if (kind === 'duplicate') {
          this.isLoading = false
          await this.confirmDuplicate(data)
          return
        }

        if (!success) throw new Error(message)

        const {norm = false} = data
        if (norm !== false && this.autoNavigate) {
          this.$router.push({name: 'apps-pasien-detail', params: {norm}})
        }

        // Show appropriate success message based on mode
        const successMessage = this.type === 'create'
          ? 'Sukses Menambahkan Pasien Baru'
          : 'Sukses Mengubah Data Pasien'
        this.$dekatoast.success(successMessage)

        this.$refs.modalPasienCreate.hide()
        this.$emit('refreshData')
      } catch (err) {
        // Handle specific backend validation errors
        this.handleSubmissionError(err)
      } finally {
        this.isLoading = false
      }
    },

    handleSubmissionError(error) {
      if (error.response && error.response.data) {
        const responseData = error.response.data

        // Handle Laravel validation errors
        if (responseData.errors) {
          const fieldErrors = []
          Object.keys(responseData.errors).forEach(fieldName => {
            const fieldLabel = this.getFieldLabel(fieldName)
            if (responseData.errors[fieldName] && responseData.errors[fieldName].length > 0) {
              fieldErrors.push(`• ${fieldLabel}: ${responseData.errors[fieldName][0]}`)
            }
          })

          if (fieldErrors.length > 0) {
            const errorMessage = fieldErrors.join('\n')
            this.$dekatoast.error(
              'Validasi Data Gagal',
              errorMessage,
              'AlertTriangleIcon'
            )
            return
          }
        }

        // Handle single error message
        if (responseData.message) {
          this.$dekatoast.error('Data Pasien Gagal Disimpan!', responseData.message)
          return
        }

        // Handle line-specific error (like NIK undefined)
        if (responseData.error && responseData.line) {
          this.$dekatoast.error(
            'Error Server',
            `${responseData.error} (Line: ${responseData.line})`,
            'AlertTriangleIcon'
          )
          return
        }
      }

      // Fallback error message
      this.$dekatoast.error(
        'Data Pasien Gagal Disimpan!',
        error?.message ?? 'Harap periksa kembali isianmu.'
      )
    },

    getFieldLabel(fieldName) {
      const fieldLabels = {
        'nik': 'NIK',
        'no_bpjs': 'No. BPJS',
        'nama': 'Nama Lengkap',
        'tempat_lahir': 'Tempat Lahir',
        'tanggal_lahir': 'Tanggal Lahir',
        'tanggal_lahir_formatted': 'Tanggal Lahir',
        'jenis_kelamin': 'Jenis Kelamin',
        'nomor_kontak_telp': 'No. Handphone',
        'nomor_kontak_wa': 'No. WhatsApp',
        'email': 'Email',
        'alamat_identitas': 'Alamat KTP',
        'alamat': 'Alamat Domisili',
        'rt': 'RT',
        'rw': 'RW',
        'rt_identitas': 'RT KTP',
        'rw_identitas': 'RW KTP',
        'kodepos': 'Kode Pos',
        'kodepos_identitas': 'Kode Pos KTP',
        'norm': 'NORM',
        'norm_manual': 'NORM Manual',
        'ibu_kandung': 'Nama Ibu Kandung',
        'agama': 'Agama',
        'status_perkawinan': 'Status Perkawinan',
        'pendidikan': 'Pendidikan',
        'pekerjaan': 'Pekerjaan',
        'suku': 'Suku',
        'golongan_darah': 'Golongan Darah',
        'kewarganegaraan': 'Kewarganegaraan',
        'perusahaan': 'Perusahaan',
        'bagian': 'Bagian',
        'nomor_induk_pegawai': 'Nomor Induk Pegawai'
      }

      return fieldLabels[fieldName] || fieldName
    },
    validateDate() {
      const tanggalLahirPasien = this.form.tanggal_lahir_formatted
      const tanggalLahirKeluarga = this.form.tanggal_lahir_keluarga_formatted
      const arr = []
      arr.push(
        tanggalLahirPasien,
        tanggalLahirKeluarga
      )
      const filter1 = arr.filter(item => item != null)
      const finalFilter = filter1.filter(item => item !== '')
      let check = 1
      for (let a = 0; a < finalFilter.length; a++) {
        if (finalFilter[a] != null || finalFilter[a] !== '') {
          check = this.getDateYear(finalFilter[a])
        }
      }

      return check
    },
    getDateYear(dates) {
      const maxDate = 120
      const data = new Date(dates)
      const year = data.getFullYear()
      const month = (data.getMonth() + 1)
      const day = data.getDate()
      const now = new Date()
      if ((now.getFullYear() - year) > maxDate) {
        return 0
      }
      if (now === year) {
        if ((now.getMonth() + 1) === month) {
          if (day > now.getDate()) {
            return 0
          }
        }
      } else {
        return 1
      }
      return 0
    },
    async validate(ref) {
      const request = await this.$refs[ref].validate()
      return request
    },
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null
    },
    syncAlamat() {
      // This modal is mounted (static) on the patient list AND detail pages and
      // binds the shared Vuex `pasien/form`. The watchers below run with
      // immediate+deep, so without this guard `syncAlamat` would overwrite
      // `form.alamat` (domisili) with `form.alamat_identitas` (KTP) whenever a
      // patient is loaded for display — making the detail view show the wrong/
      // empty address while the list (which reads `allRows`) stays correct.
      // Only mirror the address while the modal is actually open for editing.
      if (!this.isModalOpen) return
      if (this.sameAsIdentitas) {
        this.form.alamat = this.form.alamat_identitas
        this.form.provinsi = this.form.provinsi_identitas
        this.form.wilayah = this.form.wilayah_identitas
        this.form.kecamatan = this.form.kecamatan_identitas
        this.form.kelurahan = this.form.kelurahan_identitas
        this.form.rt = this.form.rt_identitas
        this.form.rw = this.form.rw_identitas
        this.form.kodepos = this.form.kodepos_identitas
      }
    },
    syncPhone() {
      if (this.sameAsPhone) {
        this.form.nomor_kontak_wa = this.form.nomor_kontak_telp
      }
    },
    syncPhoneKeluarga() {
      if (this.sameAsPhoneKeluarga) {
        this.form.nomor_kontak_keluarga_wa =
            this.form.nomor_kontak_keluarga_telp
      }
    },
    previewImage(file, form) {
      if (!file) return
      this.form[form] = URL.createObjectURL(file)
      this.$forceUpdate()
    },
    async nikHandler(nik, form, jk) {
      if (nik.length >= 12) {
        const d = this.getDateFromNik(nik)
        this.form[form] = this.$moment(d.date).format('DD/MM/YYYY')
        this.jkFromNik(d, jk)

        if (nik.length === 16 && this.form.jenis_identitas?.value === 1) {
          const availability = await this.$store.dispatch('pasien/nik', nik)

          if (availability && availability.data?.data?.exists)
            return this.duplicateNik(availability.data.data)
        }
      } else if (nik.length < 12) {
        this.form[form] = null
      }
      return null
    },
    jkFromNik(parsed, _) {
      if (parsed.d > 40) {
        this.form.jenis_kelamin = this.references['Jenis Kelamin'].find(jk => jk.value === 2) || null
      } else {
        this.form.jenis_kelamin = this.references['Jenis Kelamin'].find(jk => jk.value === 1) || null
      }
    },
    getDateFromNik(nik) {
      const currentNik = nik.toString()

      const dateString = currentNik.substring(6, 12)

      let day = dateString.substring(0, 2)
      const month = dateString.substring(2, 4)
      let year = dateString.substring(4, 6)

      if (day > 40) {
        day -= 40
      }

      if (parseInt(`20${year}`, 10) > new Date().getFullYear()) {
        year = `19${year}`
      } else {
        year = `20${year}`
      }

      return {
        date: new Date(`${year}-${month}-${day}`),
        d: dateString.substring(0, 2),
        m: month,
        y: year
      }
    },
    duplicateNik(data) {
      const h = this.$createElement
      const {norm} = data
      const messageVNode = h('div', {class: ['foobar']}, [
        h('p', {class: ['text-center']}, [
          'Pasien tersebut sudah terdaftar dengan: ',
          h('h2', {class: 'mt-1'}, `${data.nama} - ${norm}`),
          'Anda ingin menampilkan data pasien ini?'
        ])
      ])

      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Pencarian Pasien',
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          okTitle: 'Ya',
          cancelTitle: 'Tidak',
          footerClass: 'd-flex mx-auto justify-content-center'
        })
        .then((val) => {
          if (val) {
            this.closeModal()
            this.$router.push({name: 'apps-pasien-detail', params: {norm}})
          }
        })
        .catch(() => {
        })
    },
    modalPasien() {
    },
    async autofillBy(type, val) {
      try {
        const endpoint = type === 'noka' ? 'noka-fallback' : 'nik-fallback';
        const {data} = await this.$axios.get(`/pasien/bpjs/${endpoint}/${val}`);
        if (!data.status || !data.data) {
          this.$dekatoast.error(data?.message || "Data pasien tidak dapat diambil");
          return;
        }
        const {
          noKartu,
          nama,
          sex,
          tglLahir,
          noHP,
          noKTP,
        } = data.data;

        // Set nama
        this.form.nama = nama;

        // Only set NIK if we're searching by NOKA (BPJS number), preserve original NIK input when searching by NIK
        if (type === 'noka' && noKTP) {
          this.form.nik = noKTP;
        }

        // Set other fields
        this.form.no_bpjs = noKartu;
        this.form.nomor_kontak_telp = noHP;
        this.form.nomor_kontak_wa = noHP;
        this.form.tanggal_lahir_formatted = tglLahir.replace(/-/g, '/');

        // Set jenis kelamin with proper validation
        const jenisKelaminOptions = this.references['Jenis Kelamin'] || [];
        const targetValue = sex === 'L' ? 1 : 2;
        this.form.jenis_kelamin = jenisKelaminOptions.find(jk => jk.value === targetValue)?.value || null;

        this.$dekatoast.success(data.message || 'Data BPJS berhasil diambil');
      } catch (error) {
        if (error.response?.data?.message) {
          this.$dekatoast.error(error.response?.data?.message);
          return;
        }
        this.$dekatoast.error("Data pasien tidak dapat diambil");
      }
    },

    getLatestNorm() {
      axiosIns.get('/pasien/free-norm').then(({data}) => {
        this.form = {...this.form, 'norm': data.data}
      })
    },
    /**
     * Offer the operator a choice when the backend reports an existing patient with the
     * same NIK, name and date of birth. This is the path that stops a save being
     * repeated because it was believed to have failed — the reason the same person was
     * registered seven times in one afternoon.
     */
    async confirmDuplicate(duplikat) {
      const norm = duplikat && duplikat.norm
      const nama = (duplikat && duplikat.nama) || 'Pasien'
      const tanggalLahir = duplikat && duplikat.tanggal_lahir
        ? this.$moment(duplikat.tanggal_lahir).format('DD/MM/YYYY')
        : '-'

      const confirm = await this.$swal({
        title: 'Pasien Sudah Terdaftar',
        html: `<b>${nama}</b> dengan tanggal lahir ${tanggalLahir}<br>sudah terdaftar dengan <b>No. RM ${norm}</b>.`,
        icon: 'warning',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Buka Data Pasien',
        denyButtonText: 'Tetap Simpan Sebagai Baru',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary',
          denyButton: 'btn btn-outline-warning ml-1',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false
      })

      if (confirm.isConfirmed && norm) {
        this.$refs.modalPasienCreate.hide()
        this.$router.push({name: 'apps-pasien-detail', params: {norm}})
        return
      }

      if (confirm.isDenied) {
        await this.formSubmitted({abaikan_duplikat: 1})
      }
    },

    async checkNorm(toastOk = false) {
      try {
        const response = await axiosIns.get(`/pasien/check-norm/${this.form.norm}`)
        if (!response.data.data.ok) {
          const confirm = await this.$swal({
            title: 'NORM telah digunakan',
            text: `Ubah NORM menggunakan NORM yang tersedia ? (${response.data.data.freeNorm})`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1'
            },
            buttonsStyling: false
          })
          if (confirm.isConfirmed) this.form.norm = response.data.data.freeNorm
          return false
        }
        if ((this.form.norm - response.data.data.freeNorm) > 100) {
          const confirm = await this.$swal({
            title: 'Tetap Lanjukan ?',
            text: `NORM terlalu jauh dengan NORM yang terdaftar, NORM selanjutnya akan dimulai dari ${parseInt(this.form.norm, 10) + 1}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1'
            },
            buttonsStyling: false
          })
          if (!confirm.isConfirmed) return false;
          return true;
        }
        if (toastOk) {
          this.$dekatoast.success('NORM dapat digunakan');
        }
        return true;
      } catch (error) {
        if (error.response?.data?.message) {
          this.$dekatoast.error(error.response?.data?.message);
          return false;
        }
        this.$dekatoast.error("Data norm tidak dapat diambil");
        return false;
      }
    },
    onValidationFailed() {
      this.$nextTick(() => {
        const observer = this.$refs.addPasien
        if (observer && observer.flags.invalid) {
          // Get all validation errors
          const errors = observer.errors
          const fieldErrors = []

          // Collect field-specific errors
          Object.keys(errors).forEach(fieldName => {
            if (errors[fieldName] && errors[fieldName].length > 0) {
              fieldErrors.push(`• ${fieldName}: ${errors[fieldName][0]}`)
            }
          })

          if (fieldErrors.length > 0) {
            const errorMessage = fieldErrors.join('\n')
            this.$dekatoast.error(
              'Validasi Form Gagal',
              errorMessage,
              'AlertTriangleIcon'
            )
          } else {
            // Fallback to generic message if no specific errors found
            this.$dekatoast.error(
              'Ups, Gagal Validasi Form',
              '👋 Harap periksa kembali isianmu. 🙅‍♂️🙅',
              'AlertTriangleIcon'
            )
          }
        }
      })
    },

    // Ensure form data integrity before submission
    ensureFormDataIntegrity() {
      // Make sure NIK is properly set and not empty string
      if (this.form.nik === undefined || this.form.nik === '') {
        // For normal patients, NIK should not be null/empty
        if (!this.pasienTakDikenal) {
          throw new Error('NIK field is required but missing from form data');
        }
        this.form.nik = null;
      }

      // Ensure reference fields have proper values
      const referenceFields = [
        'jenis_kelamin', 'agama', 'status_perkawinan', 'pendidikan',
        'pekerjaan', 'suku', 'golongan_darah', 'kewarganegaraan'
      ];

      referenceFields.forEach(field => {
        if (this.form[field] && typeof this.form[field] === 'object') {
          // If it's an object, extract the value
          this.form[field] = this.form[field].value || this.form[field];
        }
      });
    }
  }
}
</script>
